// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23ffd700%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  min-height: 100vh;
  color: #fff;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Christmas theme colors */
:root {
  --christmas-red: #c41e3a;
  --christmas-green: #228b22;
  --christmas-gold: #ffd700;
  --christmas-silver: #c0c0c0;
  --snow-white: #fffafa;
  --dark-bg: #1a1a2e;
}

/* Dark mode friendly form elements */
select,
select.input,
select.filter-select {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px 15px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 15px center;
  padding-right: 40px;
}

select:hover,
select.input:hover,
select.filter-select:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: var(--christmas-gold);
}

select:focus,
select.input:focus,
select.filter-select:focus {
  outline: none;
  border-color: var(--christmas-gold);
  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.15);
}

select option {
  background: #1a1a2e;
  color: white;
  padding: 10px;
}

select option:hover {
  background: var(--christmas-gold);
  color: #1a1a2e;
}

/* Focus indicators for accessibility */
*:focus {
  outline: 2px solid var(--christmas-gold);
  outline-offset: 2px;
}

button:focus,
input:focus,
select:focus,
textarea:focus {
  outline: 2px solid var(--christmas-gold);
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.3);
}

/* Skip navigation link for accessibility */
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: var(--christmas-gold);
  color: var(--dark-bg);
  padding: 8px;
  text-decoration: none;
  z-index: 100;
  border-radius: 4px;
}

.skip-link:focus {
  top: 0;
}

/* Mobile-first responsive */
@media (max-width: 768px) {
  body {
    font-size: 16px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,0EAA0E;EAC1E,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;aACW;AACb;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;;;EAGE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;EAGE,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;;;;EAIE,wCAAwC;EACxC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,iCAAiC;EACjC,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,MAAM;AACR;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n  min-height: 100vh;\n  color: #fff;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Christmas theme colors */\n:root {\n  --christmas-red: #c41e3a;\n  --christmas-green: #228b22;\n  --christmas-gold: #ffd700;\n  --christmas-silver: #c0c0c0;\n  --snow-white: #fffafa;\n  --dark-bg: #1a1a2e;\n}\n\n/* Dark mode friendly form elements */\nselect,\nselect.input,\nselect.filter-select {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 12px 15px;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23ffd700' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 15px center;\n  padding-right: 40px;\n}\n\nselect:hover,\nselect.input:hover,\nselect.filter-select:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-color: var(--christmas-gold);\n}\n\nselect:focus,\nselect.input:focus,\nselect.filter-select:focus {\n  outline: none;\n  border-color: var(--christmas-gold);\n  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\nselect option {\n  background: #1a1a2e;\n  color: white;\n  padding: 10px;\n}\n\nselect option:hover {\n  background: var(--christmas-gold);\n  color: #1a1a2e;\n}\n\n/* Focus indicators for accessibility */\n*:focus {\n  outline: 2px solid var(--christmas-gold);\n  outline-offset: 2px;\n}\n\nbutton:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: 2px solid var(--christmas-gold);\n  outline-offset: 2px;\n  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.3);\n}\n\n/* Skip navigation link for accessibility */\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: var(--christmas-gold);\n  color: var(--dark-bg);\n  padding: 8px;\n  text-decoration: none;\n  z-index: 100;\n  border-radius: 4px;\n}\n\n.skip-link:focus {\n  top: 0;\n}\n\n/* Mobile-first responsive */\n@media (max-width: 768px) {\n  body {\n    font-size: 16px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
